import React from "react";

import { LibraryList } from "components/Library/LibraryList";

const LibraryListPage = () => {
  return <LibraryList />;
};
export default LibraryListPage;
